/**
 * Guard funcional sobre rutas del declarante (`declarant-section`): valida ventana de fechas de la
 * asignación antes de permitir el acceso al formulario (servicio {@link DeclarantDashboardService.validateFormLimitDate}).
 *
 * No sustituye la validación por rol; complementa el dominio **dashboard-declarant**.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastService } from 'declarabid-library';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DeclarantDashboardService } from '../../features/dashboard-declarant/services/declarant-dashboard.service';
import { UsersService } from '../../features/users/services/users.service';

function formLimitValid(valid: unknown): boolean {
  return (
    valid === true ||
    (typeof valid === 'string' && valid.trim().toLowerCase() === 'true')
  );
}

export const canAccessDeclarantStartDate: CanActivateFn = (route) => {
  const router = inject(Router);
  const declarantDashboard = inject(DeclarantDashboardService);
  const userService = inject(UsersService);
  const toast = inject(ToastService);

  const isRegistrationForm =
    route.queryParamMap.get('registrationForm') === 'true';
  const id = route.params['id'];
  const user_id = isRegistrationForm
    ? userService.currentUser().id
    : route.params['user_id'];

  if (!user_id) {
    router.navigate(['/declarant/dashboard']);
    return false;
  }

  const formId = Number(id);
  if (!Number.isFinite(formId)) {
    router.navigate(
      isRegistrationForm
        ? ['/declarant/dashboard']
        : ['/declarant/my-declarations'],
    );
    return false;
  }

  const deny = () => {
    router.navigate(
      isRegistrationForm
        ? ['/declarant/dashboard']
        : ['/declarant/my-declarations'],
    );
  };

  const toastDenied = () => {
    toast.showInfo(
      $localize`Formulario no disponible`,
      $localize`No puedes ingresar al formulario porque no estás dentro del periodo de fechas permitido.`,
    );
  };

  const toastDaysLeft = (days: number) => {
    toast.showAlert(
      $localize`Acceso no disponible`,
      $localize`La asignación aún no está disponible, Faltan ${days} día(s) para que puedas acceder.`,
    );
  };

  return declarantDashboard.validateFormLimitDate(formId).pipe(
    map((res) => {
      if (formLimitValid(res?.data?.valid || res?.data?.daysPassed > 0)) {
        return true;
      }
      if (res?.data?.daysLeft > 0) {
        toastDaysLeft(res.data.daysLeft);
      } else {
        toastDenied();
      }
      deny();
      return false;
    }),
    catchError(() => {
      toastDenied();
      deny();
      return of(false);
    }),
  );
};
